import { useEffect, useMemo, useState } from 'react';
import { FiActivity, FiInbox } from 'react-icons/fi';
import DashboardLayout from '../../components/layout/DashboardLayout';
import SectionCard from '../../components/ui/SectionCard';
import ListItem from '../../components/ui/ListItem';
import EmptyState from '../../components/ui/EmptyState';
import StatusBadge from '../../components/ui/StatusBadge';
import { getSubmissions } from '../../services/submissionService';
import { timeAgo } from '../../utils/format';

const FILTERS = [
  { value: 'all', label: 'Todos' },
  { value: 'pending', label: 'Pendientes' },
  { value: 'approved', label: 'Aprobados' },
  { value: 'rejected', label: 'Rechazados' },
];

export default function ActivityView() {
  const [submissions, setSubmissions] = useState(null);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    let active = true;
    getSubmissions().then((data) => {
      if (active) setSubmissions(data);
    });
    return () => {
      active = false;
    };
  }, []);

  const filtered = useMemo(() => {
    if (!submissions) return [];
    if (filter === 'all') return submissions;
    return submissions.filter((s) => s.status === filter);
  }, [submissions, filter]);

  return (
    <DashboardLayout title="Actividad" subtitle="Registros de todo el equipo">
      <div className="chip-row">
        {FILTERS.map((f) => (
          <button
            key={f.value}
            type="button"
            className={`chip${filter === f.value ? ' is-active' : ''}`}
            onClick={() => setFilter(f.value)}
          >
            {f.label}
          </button>
        ))}
      </div>

      <SectionCard title="Registros">
        {submissions === null && <EmptyState icon={<FiActivity />} title="Cargando actividad…" />}
        {submissions !== null && filtered.length === 0 && (
          <EmptyState
            icon={<FiInbox />}
            title="No hay registros"
            description="No encontramos registros con este filtro."
          />
        )}
        {filtered.map((item) => (
          <ListItem
            key={item.id}
            icon={<FiActivity />}
            title={item.formTitle}
            meta={`${item.submittedByName} · ${timeAgo(item.submittedAt)}`}
            right={<StatusBadge status={item.status} />}
          />
        ))}
      </SectionCard>
    </DashboardLayout>
  );
}
